import { render, staticRenderFns } from "./CertData.vue?vue&type=template&id=8df5b2f4&"
import script from "./CertData.vue?vue&type=script&lang=js&"
export * from "./CertData.vue?vue&type=script&lang=js&"
import style0 from "./CertData.vue?vue&type=style&index=0&id=8df5b2f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports